<div class="d-flex flex-nowrap flex-column gap-3 align-items-end">
  <base-button
    *ngIf="isOfferConfirmed"
    [size]="buttonSizes.xs"
    (click)="toOperations(offer.data)"
    label="operations.to"
    color="dark"
  ></base-button>
  <base-button
    [size]="buttonSizes.xs"
    *ngIf="isPreselectButtonAvailable || isUnselectButtonAvailable"
    [color]="offer.data.preselected ? 'secondary' : 'primary'"
    [label]="offer.data.preselected ? 'inquiry.unselectOffer' : 'inquiry.preselectOffer'"
    [ngClass]="{ 'unselect-offer-button': offer.data.preselected }"
    (btnClick)="handleOfferPreselection()"
    class="small-padding"
  ></base-button>
  <base-button
    *ngIf="isAcceptButtonAvailable"
    label="inquiry.acceptOffer"
    (click)="openAcceptOfferModal()"
    [size]="buttonSizes.xs"
    color="primary"
  ></base-button>
  <base-button
    *ngIf="isRejectButtonAvailable || isWithdrawButtonAvailable"
    [size]="buttonSizes.xs"
    [label]="isOfferOpen ? 'inquiry.rejectOffer' : 'inquiry.withdrawAndReject'"
    (click)="openRejectOfferModal()"
    color="secondary"
  ></base-button>
</div>

<ng-template #rejectOfferTemplate>
  <base-customer-reject-offer-modal
    *ngIf="offer.data.inquiryId"
    [modalRef]="modalRef"
    [inquiryId]="offer.data.inquiryId"
    [offerId]="offer.data.id"
    [fullName]="profileName"
  ></base-customer-reject-offer-modal>
</ng-template>

<ng-template #acceptOfferModal>
  <p
    [innerHTML]="
      'inquiry.acceptOfferConfirmation'
        | translate: { fullName: offer.data.profile.firstName + ' ' + offer.data.profile.lastName }
    "
  ></p>
  <base-expansion-panel
    *ngIf="offer.data.industrySurcharges"
    title="industrySurcharges.plural"
    titleClass="headline-20 mb-0"
  >
    <base-industry-surcharges
      [surcharges]="offer.data.industrySurcharges!"
      [showCategoryAndMethod]="true"
    ></base-industry-surcharges>
  </base-expansion-panel>
</ng-template>
